<script>
    import "firebase/firestore";
    import { getContext, createEventDispatcher } from 'svelte';

    import { isNullOrUndefined } from '../utils';

    export let id;
    export let title;

    const dispatch = createEventDispatcher();
    const db = getContext('firebase').getFirebase().firestore();

    let editing = false;
    let newTitle = '';

    function toggleEditing() {
        newTitle = newTitle.trim();
        if (editing && newTitle.length > 0) {
            dispatch('updateTitle', {
                newTitle
            });
        } else if (title) {
            newTitle = title;
        }
        editing = !editing;
    }

    function onDeleteTitle() {
        editing = false;
        db.collection('locations').doc(id).update({ title: '' });
    }
</script>

<div>
    {#if editing}
        <input bind:value={newTitle} type="text">
    {:else}
        {#if isNullOrUndefined(title) || title.length === 0}
            <span class="dne">No Title</span>
        {:else}
            <span>{title}</span>
        {/if}
    {/if}
    <i on:click={toggleEditing} class={(editing) ? "far fa-check" : "far fa-pencil"}></i>
    <i on:click={onDeleteTitle} class="far fa-trash-alt"></i>
</div>

<style>
    span {
        font-size: 36px;
        font-weight: 700;
        vertical-align: middle;
        padding-right: 10px;
    }

    input[type=text] {
        width: 85%;
        padding: 0px 10px 0px 10px;
        font-size: 36px;
        font-weight: 700;
        margin: -10px 0px 5px -10px;
        border: 1px solid var(--black);
    }

    i {
        cursor: pointer;
        font-size: 28px;
        vertical-align: middle;
        -webkit-transition: all var(--fast);
        transition: all var(--fast);
    }

    i:hover {
        color: var(--primary);
    }

    .dne {
        color: var(--grey);
    }
</style>
